"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumHarnessConnector = void 0;
const SchDocTypes_1 = require("../SchDocTypes");
class AltiumHarnessConnector {
    constructor(schematic, record) {
        this.schematic = schematic;
        this.record = record;
    }
    getEntries() {
        const children = this.schematic.getHarnessConnectorChildren(this.record.index);
        return children.filter((r) => r.recordType === SchDocTypes_1.RecordType.HARNESS_ENTRY);
    }
    getHarnessType() {
        const children = this.schematic.getHarnessConnectorChildren(this.record.index);
        return children.find((r) => r.recordType === SchDocTypes_1.RecordType.HARNESS_TYPE);
    }
    getHarnessTypeText() {
        return this.getHarnessType()?.text;
    }
    getEntryByName(name) {
        return this.getEntries().find((e) => e.name === name);
    }
}
exports.AltiumHarnessConnector = AltiumHarnessConnector;
//# sourceMappingURL=AltiumHarnessConnector.js.map